var compare_price_map = {};
$('.collect-sidebar-item.lv2>a').click(function (e) {
  e.preventDefault();
  $(this).next().slideToggle();
  // $(this).next().is(':hidden') ? $(this).find('i').removeClass('active') : $(this).find('i').addClass('active')
});


$('.collect-sidebar-select').click(function () {
  $('.collect-sidebar-list').slideToggle();
  $(this).next()
})



if (isMobile()) {
  let title = $('.collect-sidebar-item.active').attr('data-title');
  let subTitle = $('.collect-sidebar-down a.on').text();
  $('.collect-sidebar-val').val(title || subTitle)
}



if (isMobile()) {
  let width = $('.collect-compare-table').width();
  $('.collect-compare-table').width(width + 100)
}
$('.collect-toggle').click(function () {
  $(this).toggleClass('active');
  $(this).parent().prev().toggleClass('active')
})

let sideItem = document.querySelectorAll('.collect-sidebar-item');
sideItem.forEach(item => {
  if ($(item).hasClass('lv2')) {
    if ($(item).find('.collect-sidebar-down').find('a').hasClass('on')) {
      $(item).addClass('active');
    }
  }
});

let codeCopy2 = document.querySelectorAll('.collect-code-btn');
let clipboard2 = new Clipboard(codeCopy2);
clipboard2.on('success', function (e) {
  let successCon = "<div class='tb-toast'>Successfully copied!</div>"
  $('body').append(successCon);
  setTimeout(function () {
    $('.tb-toast').remove();
  }, 1000)
});


$('.collect-add-btn').click(function (e) {
  let id = $(this).attr('data-variantid') || $(this).attr('data-id');
  console.log('addbuyid',id);
  $('#loading').addClass('active');
  addCartFn(id)
})
function addCartFn(id){
  let formDate = {
    form_type: 'product',
    utf8: '✓',
    quantity:1,
    id,
  }
  $.ajax({
    url: '/cart/add.js',
    type: 'POST',
    data: formDate,
    dataType: 'json',
    success(res) {
      if (res) {
        getCartData();
      }
    },
    error(err) {
      let responseText = JSON.parse(err.responseText);
      if (err.status == 422) {
        let successCon = "<div class='tb-toast'>" + responseText.description + "</div>"
        $('body').append(successCon);
        setTimeout(function () {
          $('.tb-toast').remove();
        }, 1000)
      }
    }
  });
}


if (isMobile()) {
  var swiper = new Swiper(".navSwiper", {
    slidesPerView : 2.6,
  });
}

$('.variant-button').click(function(){
  let variantId = $(this).data('variant-id');
  let productId = $(this).data('product-id');
  let variantImage = $(this).data('variant-image');
  let variantImageWap = $(this).data('variant-image-wap');
  let variantUrl = $(this).data('url');
  let variantPrice = $(this).data('price');
  let variantCompareAtPrice = $(this).data('compare-at-price');
  let parent = $(this).closest('.module4container');
  parent.find('.variant-button').removeClass('tw-bg-black tw-text-white').addClass('tw-text-[#863F6C]');
  $(this).addClass('tw-bg-black tw-text-white').removeClass('tw-text-[#863F6C]');
  parent.find('.product-image-'+productId).attr('src',variantImage);
  parent.find('.product-image-wap-'+productId).attr('src',variantImageWap);
  parent.find('.collect-add-btn').attr('data-variantid',variantId);
  parent.find('.product-link-'+productId).attr('href',variantUrl);
  parent.find('.product-price-'+productId).text(variantPrice);
  parent.find('.product-compare-price-'+productId).text(variantCompareAtPrice);
  parent.find('.buy-button-'+productId).attr('data-variantid',variantId);
  parent.find('.product-link-'+productId).attr('href',variantUrl);
});